import { EbookOverviewTabs } from './EbookOverviewTabs'
import { withEbookOverviewTabs } from './withEbookOverviewTabs'

const ConnectedEbookOverviewTabs = withEbookOverviewTabs(EbookOverviewTabs)

export { ConnectedEbookOverviewTabs as EbookOverviewTabs }
